// extracted by mini-css-extract-plugin
module.exports = {"bulletSeparator":"BulletSeparator_bulletSeparator__8FJYi"};